import Immutable from 'immutable';
import {
  FLAG_GETTING_DEPOSIT_MIGRATIONS,
  GET_DEPOSIT_MIGRATIONS,
  CLEAR_DEPOSIT_MIGRATIONS,
  FLAG_DEPOSIT_MIGRATION_ACTIVITY,
  GET_DEPOSIT_MIGRATION,
  CLEAR_DEPOSIT_MIGRATION,
  FLAG_GETTING_DEPOSIT_MIGRATION_MOVEMENTS,
  GET_DEPOSIT_MIGRATION_MOVEMENTS,
  CLEAR_DEPOSIT_MIGRATION_MOVEMENTS,
} from '../../../actions/types';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
  movements: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case FLAG_GETTING_DEPOSIT_MIGRATIONS:
      return state.setIn(['all', 'loading'], payload);
    case GET_DEPOSIT_MIGRATIONS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_DEPOSIT_MIGRATIONS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case GET_DEPOSIT_MIGRATION:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_DEPOSIT_MIGRATION:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    case FLAG_DEPOSIT_MIGRATION_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case FLAG_GETTING_DEPOSIT_MIGRATION_MOVEMENTS:
      return state.setIn(['movements', 'loading'], payload);
    case GET_DEPOSIT_MIGRATION_MOVEMENTS:
      return state.setIn(['movements', 'content'], Immutable.Map(payload));
    case CLEAR_DEPOSIT_MIGRATION_MOVEMENTS:
      return state.setIn(
        ['movements', 'content'],
        INITIAL_STATE.getIn(['movements', 'content']),
      );
    default:
      return state;
  }
};
